import React, { useState, useEffect, useContext } from 'react'
import CommonContext from '../../product/context/common/commonContext'
import AlertContext from '../../product/context/alert/alertContext'
import { useDropzone } from 'react-dropzone'
import Loaders from '../components/molecules/Loaders'
import PrimaryButton from '../components/atoms/PrimaryButton'
import SecondaryButton from '../components/atoms/SecondaryButton'
import CustomDialog from '../components/organisms/Dialog'
import { apiCall } from './api'
import move from 'lodash-move'
import ReOrderComponet from './reorder'
import ReOrderFileNameComponet from './reorderFileName'
import { TrendingUpOutlined, TrendingUpRounded } from '@mui/icons-material'
import Webcam from 'react-webcam'
import ImageCropper from './cropper/imageCropper'
import { useTranslation } from 'react-i18next'

const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: 'user',
}

// SECURITY: client-side upload guard used by BulkUpload/ProjectImage.js.
// This only rejects obviously oversized/disallowed files in the browser
// before they're sent - the backend must independently re-validate file
// size/type, since a direct request to the upload endpoint bypasses this.
export const MAX_UPLOAD_SIZE = 10 * 1024 * 1024 // 10MB

const ALLOWED_IMAGE_MIME_TYPES = new Set([
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/bmp',
])

export const isSafeClientUpload = (file) => {
    if (!file) return false
    if (file.size > MAX_UPLOAD_SIZE) return false
    return ALLOWED_IMAGE_MIME_TYPES.has(file.type)
}

let randomVariable = Math.random()
const Uploader = (props) => {
    const [reload, setReload] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [capturePicture, setCapturePicture] = useState(false)
    const [editImageModal, setEditImageModal] = useState(false)
    const [editImageState, setEditImageState] = useState(false)
    const [nonEditedImages, setNonEditedImages] = useState([])
    const [originalFileName, setOriginalFileName] = useState('')
    const [cropLoader, setCropLoader] = useState(false)
    const commonContext = useContext(CommonContext)
    const {
        uploadImage,
        uploadedFiles,
        getImageBase,
        rotateImageBase,
        imageBaseValue,
        resetDropZone,
        responseStatus: responseStatusImage,
        clearResponse: clearResponseImage,
    } = commonContext
    const formik = props.formik
    const disabled = props?.disabled ? props.disabled : false
    const [picture, setPicture] = useState('')
    const webcamRef = React.useRef(null)
    const capture = React.useCallback(() => {
        const pictureSrc = webcamRef.current.getScreenshot({
            width: 1280,
            height: 720,
        })
        setPicture(pictureSrc)
    })

    const { t } = useTranslation()
    const closeFunction = () => {
        setCapturePicture(false)
    }
    const [editId, setEditId] = useState(null)
    const [editName, setEditName] = useState(null)

    const [currImg, setCurrImg] = useState(null)

    const urltoFile = (dataurl, filename) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n)

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type: mime })
    }

    // Function to fetch an image from a URL and convert it to Base64
    // function imageUrlToBase64(imageUrl, callback) {
    //     fetch(imageUrl)
    //         .then((response) => response.blob())
    //         .then((blob) => {
    //             const reader = new FileReader()
    //             reader.onload = function () {
    //                 callback(reader.result)
    //             }
    //             reader.readAsDataURL(blob)
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching and converting image:', error)
    //         })
    // }

    // const imageUrl =
    //     'https://minnbid-api-test.ecommerce.auction/uploads/product/file_upload-1692974307349_537381.png'

    // useEffect(() => {
    //     console.log(
    //         imageUrlToBase64(imageUrl, function (base64String) {
    //             return base64String
    //         }),
    //         'imageUrlToBase64'
    //     )
    // }, [])

    const auctionAvatar = useDropzone({
        accept: props.accept,
        multiple: props.multiple,
        onDrop: (acceptedFiles) => {
            if (acceptedFiles.length) {
                const currentValues = formik.values[props.name]
                const currentCount = Array.isArray(currentValues)
                    ? currentValues.length
                    : 0
                if (props.maxLength && currentCount >= props.maxLength) {
                    setAlert(
                        `Límite máximo de ${props.maxLength} fotos alcanzado`,
                        'error'
                    )
                    return
                }
                setIsLoading(true)
                let validation = true
                let filesToUpload = acceptedFiles
                if (props.maxLength) {
                    const remaining = props.maxLength - currentCount
                    filesToUpload = acceptedFiles.slice(0, remaining)
                    if (filesToUpload.length < acceptedFiles.length) {
                        setAlert(
                            `Solo se pueden añadir ${remaining} foto(s) más. Límite de ${props.maxLength}.`,
                            'error'
                        )
                    }
                }
                let arr = filesToUpload.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
                if (props?.getBlobUrl) {
                    props.getBlobUrl(filesToUpload[0])
                }
                let hasVideo = arr.some((file) =>
                    file.type.startsWith('video/')
                )
                var formData = new FormData()
                formData.append('folder', props.folder)
                formData.append(
                    'isCompress',
                    hasVideo ? false : props.isCompress
                )
                formData.append('quality', props.quality || '80')
                formData.append('resultWidth', props.resultWidth || '500')
                formData.append('resultHeight', props.resultHeight || '500')
                if (global?.thumbNailquality) {
                    formData.append(
                        'thumbNailquality',
                        global?.thumbNailquality || '90'
                    )
                }

                arr.forEach((value, key) => {
                    formData.append('file_upload', value)
                })
                if (validation) {
                    uploadImage(formData, props.name)
                } else {
                    setAlert('Incorrect Format', 'error')
                }
            }
        },
        disabled: disabled === true ? true : false,
    })

    const getCroppedImage = (image) => {
        setIsLoading(true)
        let convertedFile = urltoFile(image, formik.values[props.name][editId])
        Object.assign(convertedFile, {
            path: formik.values[props.name][editId],
        })

        var formData = new FormData()
        formData.append('folder', props.folder)
        formData.append('isCompress', props.isCompress)
        formData.append('quality', props.quality || '80')
        formData.append('resultWidth', props.resultWidth || '500')
        formData.append('resultHeight', props.resultHeight || '500')
        formData.append('file_upload', convertedFile)
        if (global?.thumbNailquality) {
            formData.append(
                'thumbNailquality',
                global?.thumbNailquality || '90'
            )
        }
        uploadImage(formData, props.name)
    }

    useEffect(() => {
        if (props?.webcam && props?.capture) {
            setCapturePicture(true)
        } else {
            setCapturePicture(false)
        }
    }, [props?.webcam])

    useEffect(() => {
        if (props.name === uploadedFiles.from && uploadedFiles.files.length) {
            if (props.multiplefilename) {
                let uploadedImage = []
                uploadedFiles.files &&
                    uploadedFiles.files.map((uploaded) => {
                        uploadedImage.push({
                            file_name: uploaded.file_name,
                            originalname: uploaded.originalname,
                        })
                    })
                props.formik.setFieldValue(props.name, [
                    ...formik.values[props.name],
                    ...uploadedImage,
                ])
            } else if (props.multiple) {
                let uploadedImage = []
                let previousImage = formik.values[props.name]

                uploadedFiles.files &&
                    uploadedFiles.files.map((uploaded) => {
                        uploadedImage.push(uploaded.file_name)
                    })

                if (global.removeEditedImage) {
                    if (
                        editId !== null &&
                        editId >= 0 &&
                        editId < previousImage.length
                    ) {
                        if (global.editImageAfterUpload) {
                            let valueToFind = previousImage[editId] // Value from array1
                            let indexInArray2 =
                                nonEditedImages.indexOf(valueToFind)

                            let copyArray = [...nonEditedImages]
                            const newArray = copyArray.filter(
                                (_, i) => i !== indexInArray2
                            )

                            setNonEditedImages(newArray)
                        }

                        const editedIndex = editId
                        let newPrevious = [...previousImage]
                        previousImage = newPrevious.filter(
                            (_, i) => i !== editedIndex
                        )
                        setEditId(null)

                        // Keep the edited image at its original position
                        // instead of appending it to the end of the array.
                        previousImage.splice(editedIndex, 0, ...uploadedImage)

                        props.formik.setFieldValue(props.name, previousImage)
                    } else {
                        setNonEditedImages([...uploadedImage])
                        props.formik.setFieldValue(props.name, [
                            ...previousImage,
                            ...uploadedImage,
                        ])
                    }
                } else {
                    props.formik.setFieldValue(props.name, [
                        ...previousImage,
                        ...uploadedImage,
                    ])
                }
            } else {
                uploadedFiles.files &&
                    uploadedFiles.files.map((uploaded) => {
                        if (props.showFileName) {
                            setOriginalFileName(uploaded?.originalname)
                        }
                        props.formik.setFieldValue(props.name, [
                            uploaded.file_name,
                        ])
                    })
            }
            setIsLoading(false)
            setReload(!reload)
            resetDropZone(uploadedFiles.from)
        }
    }, [uploadedFiles, editId])

    useEffect(() => {
        if (responseStatusImage) {
            if (responseStatusImage.from === `rotateImageBase-${props.name}`) {
                if (responseStatusImage.status === 'success') {
                    setIsLoading(false)
                    setAlert(t(responseStatusImage.message), 'success')
                    setReload(!reload)
                } else {
                    setIsLoading(false)
                    setAlert(t(responseStatusImage.message), 'error')
                }
                clearResponseImage()
            }
        }
    }, [responseStatusImage])

    useEffect(() => {
        if (responseStatusImage) {
            if (props.name === responseStatusImage.from) {
                if (responseStatusImage.status === 'error') {
                    setIsLoading(false)
                    setAlert(t(responseStatusImage.message), 'error')
                    clearResponseImage()
                }
            }
        }
    }, [responseStatusImage])

    const uploadFunction = async (file) => {
        const formData = new FormData()
        formData.append('imageuploads', file)
        formData.append('base64', true)
        const [res] = await Promise.all([
            apiCall(
                'post',
                'muliple_img_base64',
                formData,
                '',
                'image_uploader',
                true
            ),
        ])
        if (res.data.status === 'success') {
            // let file = res.data.data.responseData?.files[0]?.file_name
            let file = res.data.data.responseData?.files
            // urls.default = `${global.site_url}/uploads/templates/${file}`
            // return Promise.resolve({ urls })
        } else {
            // return Promise.reject('Upload Failed!')
        }
    }

    useEffect(() => {
        if (props.webcam && picture != '' && picture !== null) {
            const fileConverted = urltoFile(picture, 'test.jpg', 'image/jpeg')
            var formData = new FormData()
            formData.append('folder', props.folder)
            formData.append('isCompress', props.isCompress)
            formData.append('quality', props.quality || '80')
            formData.append('resultWidth', props.resultWidth || '500')
            formData.append('resultHeight', props.resultHeight || '500')
            formData.append('file_upload', fileConverted)
            if (global?.thumbNailquality) {
                formData.append(
                    'thumbNailquality',
                    global?.thumbNailquality || '90'
                )
            }
            uploadImage(formData, props.name)
            setCapturePicture(false)
            setPicture('')

            // uploadImage(formData, props.name)
        }
    }, [picture])

    const getFileExtension = (file) => {
        if (file) return /[.]/.exec(file) ? /[^.]+$/.exec(file)?.[0] : undefined
        else return ''
    }

    const removeFile = (file, from, index) => {
        if (props.name === from) {
            const allFiles = formik.values[props.name]
            if (index > -1) {
                allFiles.splice(index, 1)
            }
            formik.setFieldValue(props.name, allFiles)
        }
    }

    const isValidHttpUrl = (string) => {
        let url

        try {
            url = new URL(string)
        } catch (_) {
            return false
        }

        return url.protocol === 'http:' || url.protocol === 'https:'
    }

    const changeDialogStatus = () => {
        setCapturePicture(false)
    }

    const viewFile = (file, from) => {
        if (props.name === from) {
            let newWindow = null
            if (isValidHttpUrl(file)) {
                newWindow = window.open(
                    `${file}`,
                    '_blank',
                    'noopener,noreferrer'
                )
            } else {
                if (global.customImgurl) {
                    newWindow = window.open(
                        `${process.env.REACT_APP_IMAGE_URL}/uploads/${props.folder}/${file}`,
                        '_blank',
                        'noopener,noreferrer'
                    )
                } else {
                    newWindow = window.open(
                        `${global.site_url}/uploads/${props.folder}/${file}`,
                        '_blank',
                        'noopener,noreferrer'
                    )
                }
            }

            if (newWindow) newWindow.opener = null
        }
    }

    const onReorder = (e, from, to) => {
        let changedArray = move(formik.values[props.name], from, to)
        formik.setFieldValue([props.name], changedArray)
    }

    const [validImageUrl, setValidImageUrl] = useState(false)

    const checkValidImageUrl = async (file) => {
        let promise = new Promise((resolve) => {
            var img = new Image()
            img.addEventListener('load', () => resolve(true))
            img.addEventListener('error', () => resolve(false))
            img.src = file
        })

        await promise.then((res) => {
            setValidImageUrl(res)
        })
    }

    const handleImageEditModal = (open, file, index) => {
        setCropLoader(true)
        setEditImageModal(open)
        setEditName(props.name)
        setEditId(index)
        // randomVariable = Math.random()
        setEditImageState(!editImageState)
        getImageBase(
            {
                file_folder: props.folder || 'product',
                file_name: file,
            },
            randomVariable
        )
        setTimeout(() => {
            setCropLoader(false)
        }, 1200)
    }

    useEffect(() => {
        if (imageBaseValue.from === randomVariable) {
            if (imageBaseValue.record) {
                let convBase =
                    `data:image/${
                        getFileExtension(formik.values[props.name][editId]) ||
                        'png'
                    };base64,` + imageBaseValue.record
                setCurrImg(convBase)
            }
        }
    }, [imageBaseValue?.record])

    const reOrderSortName = () => {
        let sortedArray = formik.values[props.name].sort((a, b) =>
            a.originalname.localeCompare(b.originalname)
        )

        formik.setFieldValue(props.name, sortedArray)
    }

    const handleImageRotate = (file, index, angle = 90) => {
        setIsLoading(true)

        // setEditName(props.name)
        // setEditId(index)
        // randomVariable = Math.random()

        rotateImageBase(
            {
                file_folder: props.folder || 'product',
                file_name: file,
                angle,
            },
            `rotateImageBase-${props.name}`
        )
    }

    return (
        <>
            <div>
                <section>
                    {!props.hideUploader ? (
                        <>
                            <div
                                {...auctionAvatar.getRootProps({
                                    className: `dropzone${
                                        props.maxLength &&
                                        Array.isArray(
                                            formik.values[props.name]
                                        ) &&
                                        formik.values[props.name].length >=
                                            props.maxLength
                                            ? ' disabled'
                                            : ''
                                    }`,
                                })}
                            >
                                <input {...auctionAvatar.getInputProps()} />
                                <span className="material-icons">
                                    {props.icon}
                                </span>
                                <h4>{props.titleText}</h4>
                                <h6>{props.innerText}</h6>
                            </div>
                            {props.maxLength &&
                            Array.isArray(formik.values[props.name]) &&
                            formik.values[props.name].length >=
                                props.maxLength ? (
                                <p className="validationError text-left">
                                    {`Límite máximo de ${props.maxLength} fotos alcanzado`}
                                </p>
                            ) : null}
                        </>
                    ) : null}

                    <p className="validationError text-left">
                        {formik.touched[props.name] &&
                            formik.errors[props.name] &&
                            formik.errors[props.name]}
                    </p>

                    <aside className="thumbsContainer">
                        <>
                            {isLoading ? (
                                <Loaders isLoading={isLoading} />
                            ) : formik.values[props.name] &&
                              formik.values[props.name].length ? (
                                <>
                                    {props.reorder ? (
                                        <>
                                            {' '}
                                            {props.multiplefilename ? (
                                                <ReOrderFileNameComponet
                                                    props={props}
                                                    formik={formik}
                                                    removeFile={removeFile}
                                                    viewFile={viewFile}
                                                    handleImageEditModal={
                                                        handleImageEditModal
                                                    }
                                                    handleImageRotate={
                                                        handleImageRotate
                                                    }
                                                />
                                            ) : (
                                                <ReOrderComponet
                                                    props={props}
                                                    formik={formik}
                                                    removeFile={removeFile}
                                                    viewFile={viewFile}
                                                    handleImageEditModal={
                                                        handleImageEditModal
                                                    }
                                                    handleImageRotate={
                                                        handleImageRotate
                                                    }
                                                />
                                            )}
                                        </>
                                    ) : (
                                        formik.values[props.name].map(
                                            (file, index) => (
                                                <div
                                                    className="thumb"
                                                    key={index}
                                                >
                                                    <div className="thumbInner">
                                                        {(getFileExtension(
                                                            file
                                                        ) === 'png' ||
                                                            getFileExtension(
                                                                file
                                                            ) === 'jpg' ||
                                                            getFileExtension(
                                                                file
                                                            ) === 'webp' ||
                                                            getFileExtension(
                                                                file
                                                            ) === 'jpeg' ||
                                                            checkValidImageUrl(
                                                                file
                                                            )) &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'csv' &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'xlsx' &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'pdf' &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'mp4' &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'mp3' &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'doc' &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'docx' &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'zip' &&
                                                        getFileExtension(
                                                            file
                                                        ) !== 'rar' ? (
                                                            <div className="thumbCnt">
                                                                {isValidHttpUrl(
                                                                    file
                                                                ) ? (
                                                                    <>
                                                                        {props.custom ? (
                                                                            <img
                                                                                src={`${file?.replace(
                                                                                    'www.',
                                                                                    'staging.'
                                                                                )}?t=${Date.now()}`}
                                                                                className="img"
                                                                                id={
                                                                                    'thumb_' +
                                                                                    index
                                                                                }
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                src={`${file}?t=${Date.now()}`}
                                                                                className="img"
                                                                                id={
                                                                                    'thumb_' +
                                                                                    index
                                                                                }
                                                                            />
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <img
                                                                        src={`${
                                                                            global.site_url
                                                                        }/uploads/${
                                                                            props.isCompress
                                                                                ? props.folder +
                                                                                  '/compressed'
                                                                                : props.folder
                                                                        }/${file}?t=${Date.now()}`}
                                                                        className="img"
                                                                        id={
                                                                            'thumb_' +
                                                                            index
                                                                        }
                                                                    />
                                                                )}

                                                                {/* Top Rotate Buttons - only show if not disabled */}
                                                                {!props.disableRotate && (
                                                                    <div
                                                                        className="fileActionsTop"
                                                                        onPointerDown={(
                                                                            e
                                                                        ) =>
                                                                            e.stopPropagation()
                                                                        }
                                                                        onMouseDown={(
                                                                            e
                                                                        ) =>
                                                                            e.stopPropagation()
                                                                        }
                                                                    >
                                                                        <span
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.stopPropagation()
                                                                                handleImageRotate(
                                                                                    file,
                                                                                    index,
                                                                                    -90
                                                                                )
                                                                            }}
                                                                            className="rotateBtn material-icons"
                                                                            title="Rotate Left 90°"
                                                                        >
                                                                            rotate_left
                                                                        </span>
                                                                        <span
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.stopPropagation()
                                                                                handleImageRotate(
                                                                                    file,
                                                                                    index,
                                                                                    90
                                                                                )
                                                                            }}
                                                                            className="rotateBtn material-icons"
                                                                            title="Rotate Right 90°"
                                                                        >
                                                                            rotate_right
                                                                        </span>
                                                                    </div>
                                                                )}

                                                                <div
                                                                    className="fileActions"
                                                                    onPointerDown={(
                                                                        e
                                                                    ) =>
                                                                        e.stopPropagation()
                                                                    }
                                                                    onMouseDown={(
                                                                        e
                                                                    ) =>
                                                                        e.stopPropagation()
                                                                    }
                                                                >
                                                                    {props.disableDeleting ? null : (
                                                                        <span
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.stopPropagation()
                                                                                removeFile(
                                                                                    file,
                                                                                    props.name,
                                                                                    index
                                                                                )
                                                                            }}
                                                                            className="cancelBtn material-icons"
                                                                        >
                                                                            delete
                                                                        </span>
                                                                    )}
                                                                    <span
                                                                        onClick={(
                                                                            e
                                                                        ) => {
                                                                            e.stopPropagation()
                                                                            viewFile(
                                                                                file,
                                                                                props.name
                                                                            )
                                                                        }}
                                                                        className="viewBtn material-icons"
                                                                    >
                                                                        visibility
                                                                    </span>

                                                                    {props.disableEditing ? null : (
                                                                        <span
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.stopPropagation()
                                                                                handleImageEditModal(
                                                                                    true,
                                                                                    file,
                                                                                    index
                                                                                )
                                                                            }}
                                                                            className="editBtn material-icons"
                                                                        >
                                                                            edit
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <div className="thumbCnt">
                                                                    <div className="defaultThumb">
                                                                        <span className="material-icons">
                                                                            {getFileExtension(
                                                                                file
                                                                            ) ===
                                                                            'pdf'
                                                                                ? 'picture_as_pdf'
                                                                                : getFileExtension(
                                                                                      file
                                                                                  ) ===
                                                                                      'doc' ||
                                                                                  getFileExtension(
                                                                                      file
                                                                                  ) ===
                                                                                      'docx'
                                                                                ? 'description'
                                                                                : getFileExtension(
                                                                                      file
                                                                                  ) ===
                                                                                      'mp4' ||
                                                                                  getFileExtension(
                                                                                      file
                                                                                  ) ===
                                                                                      'mpeg'
                                                                                ? 'movie'
                                                                                : getFileExtension(
                                                                                      file
                                                                                  ) ===
                                                                                      'mpga' ||
                                                                                  getFileExtension(
                                                                                      file
                                                                                  ) ===
                                                                                      'mp3'
                                                                                ? 'volume_up'
                                                                                : getFileExtension(
                                                                                      file
                                                                                  ) ===
                                                                                      'zip' ||
                                                                                  getFileExtension(
                                                                                      file
                                                                                  ) ===
                                                                                      'rar'
                                                                                ? 'archive' // ✅ zip/rar now show archive icon
                                                                                : 'description'}
                                                                        </span>
                                                                    </div>
                                                                    <div
                                                                        className="fileActions"
                                                                        onPointerDown={(
                                                                            e
                                                                        ) =>
                                                                            e.stopPropagation()
                                                                        }
                                                                        onMouseDown={(
                                                                            e
                                                                        ) =>
                                                                            e.stopPropagation()
                                                                        }
                                                                    >
                                                                        {props.disableDeleting ? null : (
                                                                            <span
                                                                                onClick={(
                                                                                    e
                                                                                ) => {
                                                                                    e.stopPropagation()
                                                                                    removeFile(
                                                                                        file,
                                                                                        props.name,
                                                                                        index
                                                                                    )
                                                                                }}
                                                                                className="cancelBtn material-icons"
                                                                            >
                                                                                delete
                                                                            </span>
                                                                        )}
                                                                        <span
                                                                            onClick={(
                                                                                e
                                                                            ) => {
                                                                                e.stopPropagation()
                                                                                viewFile(
                                                                                    file,
                                                                                    props.name
                                                                                )
                                                                            }}
                                                                            className="viewBtn material-icons"
                                                                        >
                                                                            visibility
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                    {props?.showFileName &&
                                                    originalFileName ? (
                                                        <h6>
                                                            {originalFileName}
                                                        </h6>
                                                    ) : null}
                                                </div>
                                            )
                                        )
                                    )}
                                    {props.multiplefilename ? (
                                        <SecondaryButton
                                            onClick={(e) => {
                                                reOrderSortName()
                                            }}
                                            className="uploaderSortButyton"
                                            label="Sort By Name"
                                        />
                                    ) : null}
                                </>
                            ) : null}
                        </>
                    </aside>
                </section>
                <div className="camShow">
                    {props.webcam ? (
                        <PrimaryButton
                            id="webcam_id"
                            onClick={() => setCapturePicture(true)}
                            btnSize="small"
                        >
                            <span className="material-icons pr-0">
                                photo_camera
                            </span>
                        </PrimaryButton>
                    ) : null}
                </div>
            </div>

            <CustomDialog
                title={'Webcam'}
                open={capturePicture}
                maxWidth={'lg'}
                function={changeDialogStatus}
                disableBackdropClick
            >
                <div>
                    {/* <h2 className="mb-5 text-center">React Photo Capture using Webcam Examle</h2> */}
                    <div>
                        {picture == '' ? (
                            <Webcam
                                audio={false}
                                height={120}
                                ref={webcamRef}
                                width={280}
                                screenshotFormat="image/jpeg"
                                videoConstraints={
                                    props.videoConstraints
                                        ? props.videoConstraints
                                        : videoConstraints
                                }
                            />
                        ) : (
                            <img src={picture} />
                        )}
                    </div>
                    <div>
                        <div className="mb-3">
                            {picture != '' ? (
                                <SecondaryButton
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setPicture('')
                                    }}
                                    label="Retake"
                                />
                            ) : (
                                <PrimaryButton
                                    onClick={(e) => {
                                        e.preventDefault()
                                        capture()
                                    }}
                                    label="Capture"
                                />
                            )}
                        </div>
                        <SecondaryButton
                            label="Cancel"
                            onClick={() => closeFunction()}
                        />
                    </div>
                </div>
            </CustomDialog>
            <CustomDialog
                title={t('Edit Image')}
                className="editImageModal"
                open={editImageModal}
                maxWidth={'lg'}
                function={() => setEditImageModal(false)}
                disableBackdropClick
            >
                <div>
                    <ImageCropper
                        imgSrc={currImg}
                        folder={props.folder}
                        loading={cropLoader}
                        editId={editId}
                        getCroppedImage={getCroppedImage}
                        onClose={() => setEditImageModal(false)}
                    />
                </div>
            </CustomDialog>
        </>
    )
}

export default Uploader
